/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
// import classes from '../activation/activate.module.css'
import classes from "./order.module.css";
import Loader from "../../../component/loader";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import Breadcrumb from "../../../component/breadcrumb";
import Grid from "@mui/material/Grid";
import PhysicalProducts from "./physicalProducts";

/*
Class used for Return & Exchange.
Calls cont : Physical Products
*/
class ReturnExchange extends Component {
  // Declare property values that belongs to the component
  constructor(props) {
    super(props);

    this.state = {
      tabs: [],
      bread: [],
      tabValue: 0,
      orderId: "",
      loading: false,

      //set the data
      customerDetails: {},
      returnExchangeData: [],
      physicalProductData: [],

      //show the table
      displayPhysicalProductData: false,

      edit: {},
      solutions: [],
      accessories: [],
      associationType: [
        { name: "DEVICE", value: "devices" },
        { name: "DATA-PLAN", value: "dataPlans" },
        { name: "SMS-PLAN", value: "smsPlans" },
        { name: "SETUP", value: "setup" },
        { name: "SERVICES", value: "services" },
        { name: "ADDON", value: "addons" },
      ],

      apiPayload: {},
      orderReturnList: [],
    };
  }

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.props.setCompDidMount();
    let bread = [
      { title: "Orders", url: "/orders" },
      {
        title: this.props.router.params.id,
        url: `/order/${this.props.router.params.id}`,
      },
      { title: "Returns", url: `/return/${this.props.router.params.id}` },
    ];
    this.setState({ loading: true });

    let payLoad = {
      orderId: this.props.router.params.id,
    };
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_ORDER_RETURNABLE_ITEMS/endpoint`,
      payLoad,
    )
      .then((res) => {
        this.setState(
          {
            orderReturnList: res.data.orderReturnList,
            orderItemDetails: res.data.orderItemDetails,
            returnableItemList: res.data.returnableItemList,
          },
          () => {
            BusApiCall(
              "GET",
              `${constants.busV4Url}/orders/${this.props.router.params.id}`,
            )
              .then((res) => {
                this.setState(
                  {
                    bread,
                    loading: true,
                    orderId: this.props.router.params.id,
                    customerDetails: res.data.customer,
                  },
                  () => {
                    if (res.data.orderItems) {
                      let newSolutions = [];
                      // Check each iitem in order
                      for (let item of res.data.orderItems) {
                        if (item.associatedProducts) {
                          let data = {};
                          for (let lineItem of item.associatedProducts) {
                            // Get solution plans
                            if (lineItem.associationType === "SOLUTION_PLAN") {
                              data.solution = {
                                id: lineItem.products[0].productId,
                                name: lineItem.products[0].productName,
                                quantity: +lineItem.products[0].quantity,
                                price: {
                                  purchasePrice: +lineItem.products[0].amount,
                                  recurringPrice:
                                    lineItem.products[0].chargeType === "NC"
                                      ? null
                                      : {
                                          price: +lineItem.products[0].amount,
                                        },
                                },
                              };
                            }
                            // Get all associations
                            if (lineItem.associationType) {
                              let type = "";
                              if (lineItem.associationType === "DEVICE") {
                                this.state.associationType.map((assoc) => {
                                  if (assoc.name === lineItem.associationType) {
                                    type = assoc.value;
                                  }
                                });
                              }
                              if (type !== "") {
                                data[type] = [];
                                if (lineItem.products) {
                                  for (let product of lineItem.products) {
                                    let obj = {
                                      id: product.productId,
                                      name: product.productName,
                                      quantity: +product.quantity,
                                      price: {
                                        purchasePrice: +product.amount,
                                        recurringPrice:
                                          product.chargeType === "NC"
                                            ? null
                                            : {
                                                price: +product.amount,
                                              },
                                      },
                                    };
                                    data[type].push(obj);
                                  }
                                }
                              }
                            }
                            newSolutions.push(data);
                          }
                        }
                      }

                      this.setState(
                        {
                          solutions: [...newSolutions],
                        },
                        () => {
                          this.setState(
                            {
                              physicalProductData:
                                this.state.returnableItemList,
                            },
                            () => {
                              this.setState({
                                displayPhysicalProductData: true,
                                loading: false,
                              });
                            },
                          );
                        },
                      );
                    }
                  },
                );
              })
              .catch((e) => {
                this.props.setErrorMessage(
                  "Something went wrong. Please try later.",
                  false,
                );
                this.setState({
                  loading: false,
                });
              });
          },
        );
      })
      .catch((e) => {
        //props.setErrorMessage("Something went wrong. Please try later.", false)
      });
  }

  getOrderReturnableItems(itemDetails) {
    this.setState(
      {
        loading: true,
        returnExchangeData: [],
      },
      () => {
        let payLoad = { orderId: this.props.router.params.id };
        BusApiCall(
          "POST",
          `${constants.busInternalUrl}/passthru/GET_ORDER_RETURNABLE_ITEMS/endpoint`,
          payLoad,
        )
          .then((res) => {
            if (res.data.orderItemDetails.length > 0) {
              res.data.orderItemDetails.map((item, i) => {
                item.expandItemRow = itemDetails[i].expandItemRow;
              });
            }
            this.setState(
              {
                displayPhysicalProductData: false,
                orderReturnList: res.data.orderReturnList,
                orderItemDetails: res.data.orderItemDetails,
                returnableItemList: res.data.returnableItemList,
              },
              () => {
                this.setState(
                  {
                    displayPhysicalProductData: true,
                  },
                  () => {
                    this.props.setErrorMessage(
                      this.props.t("Return created successfully."),
                      true,
                    );
                    this.setState({ loading: false });
                  },
                );
              },
            );
          })
          .catch((e) => {
            this.setState({ loading: false });
          });
      },
    );
  }

  submitData = (data, itemDetails, isValid) => {
    if (!isValid) {
      this.props.setErrorMessage(
        this.props.t("Return Type cannot be Blank."),
        false,
      );
      return;
    }
    this.setState(
      {
        loading: true,
        returnExchangeData: [],
      },
      () => {
        this.setState(
          {
            returnExchangeData: data,
          },
          () => {
            let request = {};
            request.returnRequest = [...this.state.returnExchangeData];
            //call API
            this.setState(
              {
                apiPayload: request,
              },
              () => {
                if (
                  this.state.apiPayload &&
                  this.state.apiPayload.returnRequest &&
                  this.state.apiPayload.returnRequest.length > 0
                ) {
                  this.props.setErrorMessage("", false);
                  BusApiCall(
                    "POST",
                    `${constants.busV4Url}/orders/${this.state.orderId}/returns`,
                    this.state.apiPayload,
                  )
                    .then((res) => {
                      this.getOrderReturnableItems(itemDetails);
                    })
                    .catch((e) => {
                      this.props.setErrorMessage(
                        "Something went wrong. Please try later.",
                        false,
                      );
                      this.setState({
                        loading: false,
                      });
                    });
                } else {
                  this.setState({
                    loading: false,
                  });
                  this.props.setErrorMessage(
                    this.props.t("No item selected to return"),
                    false,
                  );
                }
              },
            );
          },
        );
      },
    );
  };

  render() {
    const { t } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
                {this.state.customerDetails.ban && (
                  <div className={"bottomBreadcrumbText"}>
                    <h2 className={classes.orderHeaderInfo}>
                      <h3
                        className={classes.checkoutTitle}
                      >{`Account Name: ${this.state.customerDetails.companyName}`}</h3>
                      <h3 className={classes.statusTitle}>
                        {" "}
                        {`BAN: ${this.state.customerDetails.ban}`}
                      </h3>
                    </h2>
                  </div>
                )}
              </Grid>
            </Grid>
          </div>
        </div>
        <main style={{ position: "relative" }}>
          {/* <p></p> */}
          {/* Customer details */}

          {/* <div className={classes.headerDiv}>
                        {this.state.customerDetails.ban &&
                            <div>
                                <h3 className={classes.checkoutTitle}>{`Account Name: ${this.state.customerDetails.companyName}`}</h3>
                                <h3 className={classes.statusTitle}> {`BAN: ${this.state.customerDetails.ban}`}</h3>
                            </div>
                        }
                    </div> */}

          {/*<Grid container spacing={2}>*/}
          {/*    <Grid item xs={2}>{t('Account Name')}</Grid>*/}
          {/*    <Grid item xs={10}>{this.state.customerDetails.companyName}</Grid>*/}

          {/*    <Grid item xs={2}>{t('BAN')}</Grid>*/}
          {/*    <Grid item xs={10}>{this.state.customerDetails.ban}</Grid>*/}
          {/*</Grid>*/}

          {/* <CartBlock
                    solutionList={this.state.solutions}
                    accessoryList={this.state.accessories}
                    screen="returnExchange"
                    edit={this.state.edit}
                    orderStatus={this.state.status}
                    componentList={this.props.componentList}
                /> 
                    <br />
                    */}

          <Grid container>
            {/* <Grid item xs={12}>
                        <Tabs
                            value={this.state.tabValue}
                            //onChange={this.handleTabChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            className={classes.activationTabs}
                        >
                            <Tab label={t('Physical Products')} icon={<Devices />} />
                        </Tabs>
                    </Grid> */}
            <Grid
              item
              size={{
                xs: 12,
              }}
            >
              {this.state.displayPhysicalProductData && (
                <PhysicalProducts
                  id={this.state.orderId}
                  submitData={this.submitData}
                  componentType={t("Physical Product")}
                  orderReturnList={this.state.orderReturnList}
                  orderItemDetails={this.state.orderItemDetails}
                  returnItemListIds={this.state.returnItemListIds}
                  returnExchangeData={this.state.returnExchangeData}
                  physicalProductData={this.state.physicalProductData}
                  setErrorMessage={this.props.setErrorMessage}
                />
              )}
            </Grid>
          </Grid>
          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    componentList: state.cart.componentList,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(ReturnExchange));
